import baseProperty from "./component-library251.mjs";
var asciiSize = baseProperty("length");
const asciiSize$1 = asciiSize;
export {
  asciiSize$1 as default
};
